import { Button, ConfigProvider } from 'antd';
import React from 'react';

const ButtonGX = ({
  disabled = false,
  onClick = () => {},
  children,
  ...props
}) => {
  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            defaultBg: '#05805C',
            defaultColor: '#fff',
            defaultHoverBg: '#fff',
            defaultHoverColor: '#05805C',
            defaultHoverBorderColor: '#05805C',
            defaultActiveColor: '#05805C',
            defaultActiveBg: '#fff',
            defaultActiveBorderColor: '#05805C',
          },
        },
      }}
    >
      <Button
        disabled={disabled}
        onClick={onClick}
        className="px-4 py-[1rem]"
        {...props}
      >
        {children}
      </Button>
    </ConfigProvider>
  );
};

export default ButtonGX;
